export const initialize = () => ({
    type: "Initialized",
});
export const pending = () => ({ type: "Pending" });
export const succeed = (result) => ({
    type: "Success",
    result,
});
export const fail = (error) => ({
    type: "Failure",
    error,
});
export const fold = (onInitialized, onPending, onFailure, onSuccess, remote) => {
    switch (remote.type) {
        case "Initialized":
            return onInitialized();
        case "Pending":
            return onPending();
        case "Failure":
            return onFailure(remote.error);
        case "Success":
            return onSuccess(remote.result);
    }
};
